//  using ducks pattern
//  all actions, actionTypes and reducers go in the same file
// https:github.com/erikras/ducks-modular-redux

import { combineReducers } from "redux";
import { toastsReducer as toasts } from "react-toastify-redux";

import globalvars from './gvars'

// school DC
import schoolDCReducer from './schoolDataCenter';
import schoolPerceptionsReducer from './schoolPerceptions';
import schoolSFReducer from './schoolSearchFilters';

// teacher DC
import teacherDCReducer from './teacherDataCenter';
import teacherPerceptionsReducer from "./teacherPerceptions";



const appReducer = combineReducers({
  toasts,
  globalvars,
  schoolDCReducer,
  schoolPerceptionsReducer,
  schoolSFReducer,
  teacherDCReducer,
  teacherPerceptionsReducer
})

const rootReducer = (state, action) => {
  if(action.type === 'CLEAR_STORE') {
    state = undefined;
  }

  return appReducer(state, action);
}

export default rootReducer;







// WEBPACK FOOTER //
// ./src/redux/ducks/index.tsx